export default "__VITE_ASSET__05829005__"